const editMode = (state = {state:false},action)=>{
    if(action.type === 'SET_EDITING_MODE'){
        state.state = action.mode
    }
    return state;
}
export default editMode;